'use client'

import { Toaster } from 'sonner'
import { useTheme } from 'next-themes'

/**
 * Sonner defaults to theme="light" when given no theme prop, so a bare
 * <Toaster /> rendered light toasts in dark mode. next-themes' resolvedTheme
 * follows the app's class-based toggle (including "system"), which sonner's
 * own theme="system" would not — that reads the OS preference directly and
 * ignores an in-app override.
 */
export function ThemedToaster() {
  const { resolvedTheme } = useTheme()
  return <Toaster theme={resolvedTheme === 'dark' ? 'dark' : 'light'} />
}
